export const ALERT = 'ALERT';
export const CONFIRM = 'CONFIRM';
